import React from 'react';
import { AlertTriangle } from 'lucide-react';

import { allergenNotice } from '../../content/siteContent.mjs';

export const AllergenNotice = () => (
  <section className="py-16 px-4 sm:px-6 lg:px-8 bg-red-50" data-testid="allergen-notice">
    <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start gap-5">
      <AlertTriangle size={36} className="text-red-500 flex-shrink-0" aria-hidden="true" />
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">Allergen notice</h2>
        <p className="text-base text-gray-700 leading-relaxed">{allergenNotice}</p>
      </div>
    </div>
  </section>
);

export default AllergenNotice;
